import React, { ChangeEvent, memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { ShortlistSortOrder, ShortlistTableHeadProps } from '@modules/shortlist/types'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'

import SortArrow from './SortArrow'
import { TitleCheckbox } from './index.styles'

interface ProfileTitleHeadCellProps {
  allProfilesSelected: ShortlistTableHeadProps['allProfilesSelected']
  onSelectAllProfiles: ShortlistTableHeadProps['onSelectAllProfiles']
  sortOrder?: ShortlistSortOrder
  isSortActive: boolean
  hasLeftOffset?: boolean
}
const ProfileTitleHeadCell = (props: ProfileTitleHeadCellProps) => {
  const { allProfilesSelected, onSelectAllProfiles, sortOrder, isSortActive, hasLeftOffset = true } = props
  const { t } = useTranslation()
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ cursor: 'pointer', flex: '1' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <TitleCheckbox
          $hasLeftOffset={hasLeftOffset}
          checked={allProfilesSelected}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onSelectAllProfiles(e.target?.checked)
          }}
        />
      </Box>
      <Typography variant="h3">{t(translationKeys.CUSTOM_LIST_TABLE_HEADER_TITLE)}</Typography>
      <SortArrow isActive={isSortActive} order={isSortActive ? sortOrder : null} isHovered={isHovered} fieldName="profileTitle" />
    </Box>
  )
}

export default memo(ProfileTitleHeadCell)
